<!--
 * @Author: your name
 * @Date: 2021-07-24 16:10:42
 * @LastEditTime: 2021-07-31 14:09:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \hpss-ui\src\views\crmedical\value\valueitem.vue
-->
<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @on-load="onLoad"
                   @refresh-change="onLoad"
        >
            <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           v-if="permission.valueitem_delete"
                           @click="handleDelete">删 除
                </el-button>
            </template>
        </avue-crud>
    </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/crmedical/value/valueitem';
import { mapGetters } from 'vuex';

export default {
  
  data() {
    var validatePass = (rule, value, callback) => {
      let reg = /^[0-9]+$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error('请输入数字'));
      }
    };
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        searchMenuSpan:8,
        height: '400',
        calcHeight: 600,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        column: [
          {
            label: '名称',
            prop: 'name',
            search: true,
            maxlength:'30',
            rules: [
              {
                required: true,
                message: '请输入名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '编号',
            prop: 'code',
            minRows:'0',
            maxlength:'30',
            rules: [
              {
                required: true,
                message: '请输入编号',
                trigger: 'change',
              },
              { validator: validatePass, trigger: 'blur' }
            ],
          },
          {
            label: '分析类别',
            prop: 'itemType',
            type: 'select',
            maxlength:'30',
            search: true,
            dataType: 'number',
            dicUrl: '/api/blade-system/dict/dictionary?code=value_analyse_sort',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请输入分析类别，成本/创收',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '说明',
            maxlength:'50',
            prop: 'description',
            type: 'textarea',
            minRows: 1,
          },
          
          
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.valueitem_add, false),
        viewBtn: this.vaildData(this.permission.valueitem_view, false),
        delBtn: this.vaildData(this.permission.valueitem_delete, false),
        editBtn: this.vaildData(this.permission.valueitem_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params,done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done()
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style>
</style>
